import {
  Autocomplete,
  Button,
  Divider,
  Drawer,
  Fade,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Stack,
  TextField,
  Typography,
  createSvgIcon,
  useTheme,
  Tooltip,
  Chip,
  alpha,
  InputAdornment,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import IconTransform from "../iconsElement";
import {
  AnimationOutlined,
  ArrowBack,
  BackHand,
  CancelOutlined,
  Clear,
  DeleteOutline,
  DoubleArrowOutlined,
  LineStyle,
  PlayForWork,
  Redo,
  SaveAs,
  SaveOutlined,
  ShapeLineOutlined,
  SwitchAccessShortcut,
  Timeline,
  Undo,
  ViewInArOutlined,
} from "@mui/icons-material";
import { ReactComponent as LinkedSvg } from "../../../assets/easyMaps/iconsSvg/Linked.svg";
import { ReactComponent as CapacitySvg } from "../../../assets/easyMaps/iconsSvg/capacidade.svg";
import { ReactComponent as ItemSVG } from "../../../assets/easyMaps/iconsSvg/item.svg";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import {
  forwardRef,
  useEffect,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import ForkRightIcon from "@mui/icons-material/ForkRight";
import NearMeIcon from "@mui/icons-material/NearMe";
import { LoadingButton } from "@mui/lab";
import { VirtualizedListbox } from "../vitualizationAutoComplete";
import extractInterfaces from "../../../utils/easyMaps/extractInterfaces";
import extractInterfaceSelected from "../../../utils/easyMaps/extractInterfaceSelected";
import extratcItensFromInterface from "../../../utils/easyMaps/extractItensFromInterface";
import {
  extractItemIsNotTrafficNotPower,
  filterItemIsNotTrafficNotPower,
} from "../../../utils/easyMaps/itensIsNotTrafficNotPower";
import useStyles from "./styles";

import { useMapa } from "../../../contexts/mapaContext";
import { set } from "lodash";

const lineTypes = ["reta", "ortogonal", "curvada"];
const animationTypes = ["pontilhada", "tracejada"];
const EnlaceSideBarEasyMaps = forwardRef(
  (
    {
      setEdgeSelected = () => {},
      setOpenAlertModal = () => {},
      connection = null,
      setConnection = () => {},
      edgeSelected,
      api,
      produtos,
      iconsElement,
      saveConnection,
      handleDelete = () => {},
      changeConnection,
      fullScreem = false,
      autoRouting = () => {},
      cleanRouting = () => {},
      loadRouting = false,
      setLoadRouting = () => {},
      tipoMapa = 0,
      loadingButton,
      typeElement = "Host",
      handleReload = () => {},
      openEnlaceBar,
      setOpenEnlaceBar = () => {},
      elementSelected,
      editingViaElement,
      hostsConfig,
    },
    ref,
  ) => {
    const { elements, setSnackbar, checkChanges, setCheckChanges } = useMapa();
    const [line, setLine] = useState("reta");
    const [itens, setItens] = useState([]);
    const [link, setLink] = useState("");
    const [hostId, setHostId] = useState("");
    const [itemConnection, setItemConnection] = useState([]);
    const [otherItensConnection, setOtherItensConnection] = useState([]);
    const [capacidade, setCapacidade] = useState("0");
    const [iconsElementPair, setIconsElementPair] = useState([]);
    const [animation, setAnimation] = useState("");
    const [loading, setLoading] = useState(false);
    const [elementsPair, setElementsPair] = useState([]);
    const [sourceHandle, setSourceHandle] = useState(null);
    const [targetHandle, setTargetHandle] = useState(null);
    const [element, setElement] = useState(null);
    //potencia
    const [limiteSuperiorPowerRX, setLimiteSuperiorPowerRX] = useState(0);
    const [limiteInferiorPowerRX, setLimiteInferiorPowerRX] = useState(0);
    const [limiteSuperiorPowerTX, setLimiteSuperiorPowerTX] = useState(0);
    const [limiteInferiorPowerTX, setLimiteInferiorPowerTX] = useState(0);
    const [flagLimiteAutomatico, setFlagLimiteAutomatico] = useState(false);
    const [flagCapacidadeAutomatica, setflagCapacidadeAutomatica] =
      useState(false);
    //interfaces
    const [interfaces, setInterfaces] = useState([]);
    const [interfaceSelected, setInterfaceSelected] = useState(null);
    //const previousChange = usePrevious(positionHandlers);
    const theme = useTheme();
    const CapacityIcon = createSvgIcon(
      <CapacitySvg height="100%" width="100%" />,
    );
    const LinkedIcon = createSvgIcon(<LinkedSvg height="80%" width="80%" />);
    const ItemIcon = createSvgIcon(<ItemSVG height="90%" width="90%" />);
    const styles = useStyles(theme, fullScreem);
    const prevElementSelectedRef = useRef(null);

    useEffect(() => {
      if (!prevElementSelectedRef.current) {
        prevElementSelectedRef.current = elementSelected;
        return;
      }

      if (
        elementSelected &&
        prevElementSelectedRef.current?.id !== elementSelected.id
      ) {
        close();
      }

      prevElementSelectedRef.current = elementSelected;
    }, [elementSelected]);

    useImperativeHandle(ref, () => ({
      update() {
        handleSave();
      },
    }));

    // useEffect(() => {
    //   if (
    //     flagLimiteAutomatico == false ||
    //     itens.length == 0 ||
    //     interfaceSelected == null
    //   )
    //     return;
    //   let itensInterface = extratcItensFromInterface(interfaceSelected, itens);
    //   let itensLimit = itensInterface.filter((i) => i.key_?.includes("Thold"));
    // }, [itens, flagLimiteAutomatico, interfaceSelected]);

    useEffect(() => {
      if (connection != undefined) {
        let elemnt = elements?.get(connection?.destinationId);
        let imgsPair = [];
        const reference = elements?.get(connection?.referenceId);
        const destination = elements?.get(connection?.destinationId);
        let findPair = [reference, destination];

        imgsPair = [reference?.img, destination?.img];
        if (Array.isArray(findPair) && findPair.length === 2) {
          setElementsPair(findPair);
          setIconsElementPair([
            iconsElement?.find((icon) => imgsPair[0] === icon?.id),
            iconsElement?.find((icon) => imgsPair[1] === icon?.id),
          ]);
        }
        if (elemnt) {
          setElement(elemnt);
        }
        // handles
        setSourceHandle(connection?.config?.sourceHandle || null);
        setTargetHandle(connection?.config?.targetHandle || null);
        //potencias
        setLimiteSuperiorPowerRX(
          connection?.config?.limiteSuperiorPowerRX ?? 0,
        );
        setLimiteInferiorPowerRX(
          connection?.config?.limiteInferiorPowerRX ?? 0,
        );
        setLimiteSuperiorPowerTX(
          connection?.config?.limiteSuperiorPowerTX ?? 0,
        );
        setLimiteInferiorPowerTX(
          connection?.config?.limiteInferiorPowerTX ?? 0,
        );
        setFlagLimiteAutomatico(
          connection?.config?.flagLimiteAutomatico ?? false,
        );
        setflagCapacidadeAutomatica(
          connection?.config?.flagCapacidadeAutomatica ?? false,
        );

        const capacidadeConn = connection?.config?.capacidade;
        if (typeof capacidadeConn == "string") {
          const partes = capacidadeConn
            ?.replace(",", ".")
            ?.replace(/[^0-9.]/g, "")
            ?.split(".");

          const sanitizedValue =
            partes?.length > 1
              ? `${partes?.[0]}.${partes?.slice(1)?.join("")}`
              : partes?.[0];
          setCapacidade(sanitizedValue ?? "0");
        } else {
          setCapacidade(capacidadeConn ?? "0");
        }
        setAnimation(connection?.config?.animation ?? "desativada");
        setLine(connection?.config?.type || lineTypes[0]);

        let hostConnId = connection?.config?.hostOriginId; // as novas conexões carregaram esse campo (cardConnection)

        if (!hostConnId) {
          //verifica o host pelos itens da conexão
          if (Array.isArray(connection.item) && connection.item.length > 0) {
            setHostId(connection?.item[0]?.hostOriginId);
          } else {
            let elementoReference = elements?.get(connection.referenceId);
            if (elementoReference?.tipo == 0) {
              setHostId(
                elementoReference?.elementConfig?.config?.hosts[0]?.hostid,
              );
            }
            // Aqui fica sério pq em mapas ou pops temos muitos hosts e não dá para saber qual deles é a origim se nã tiver itens ou o hostOriginId,
            //nesse caso os usuarios precisaram recolocar o host de origem na conexão para que carregem o campo hostOriginId
          }
        } else {
          setHostId(hostConnId);
        }
        const produtoId = elements?.get(connection?.referenceId)?.elementConfig
          ?.config?.produtoId;
        let link = null;
        const produto = produtos.find((pro) => pro.id == produtoId);
        if (
          Array.isArray(produto?.AcessoLink) &&
          produto?.AcessoLink.length > 0
        )
          setLink(produto.AcessoLink[0]?.link);
      }
    }, [connection?.id, connection?.config, openEnlaceBar]);

    useEffect(() => {
      // Early return se não houver itens
      if (!itens?.length) {
        setInterfaces([]);
        setInterfaceSelected(null);
        setOtherItensConnection([]);
        return;
      }

      const uniqueInterfaces = extractInterfaces(itens);
      const interfaceSelected = extractInterfaceSelected(
        connection?.item,
        uniqueInterfaces,
      );
      const otherItems = extractItemIsNotTrafficNotPower(itens, connection);

      // Atualiza os estados
      setInterfaceSelected(interfaceSelected);
      setInterfaces(uniqueInterfaces);
      setOtherItensConnection(otherItems);
    }, [itens]);

    useEffect(() => {
      if (hostId == "" || hostId == null || !connection) return;
      getItens();
    }, [hostId, connection?.id]);

    useEffect(() => {
      if (connection === null) {
        clearMemory();
      }
    }, [connection]);

    function clearMemory() {
      setLoadRouting(false);
      setLine("reta");
      setItens([]);
      setLink("");
      setHostId("");
      setItemConnection([]);
      setOtherItensConnection([]);
      setCheckChanges(false);
    }
    // function close() {
    //   setConnection(null);
    //   setEdgeSelected(null);
    //   setOpenEnlaceBar(null);
    //   clearMemory();
    //   handleReload();
    // }
    function close() {
      setConnection(null);
      setOpenEnlaceBar(false);
    }

    async function getItens() {
      try {
        setItemConnection([]);
        setOtherItensConnection([]);
        if (typeElement == "Host") setLoading(true);

        const response = await api.post("/easyMaps/zabbix/itens", {
          link: link,
          hostids: hostId,
        });

        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível buscar os hosts",
            severity: "error",
          });
        } else {
          let responseItens = response.data;

          setItens([
            ...new Map(
              responseItens.map((item) => [item.itemid, item]),
            ).values(),
          ]);
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    }

    const handleSave = () => {
      if (!connection) return;

      const referenceElem = elements?.get(connection?.referenceId);
      const acessoProdutoId = referenceElem?.elementConfig?.config?.produtoId;

      const updatedConnection = {
        ...connection,
        destinationId: element?.id || null,
        item: [
          ...extratcItensFromInterface(interfaceSelected, itens),
          ...otherItensConnection,
        ].map((item) => ({
          itemId: item?.itemid || null,
          itemName: item?.name || null,
          hostOriginId: item?.hostid || null,
          acessoProdutoId: acessoProdutoId || null,
          key_: item?.key_ || null,
        })),
      };

      saveConnection(
        updatedConnection,
        edgeSelected,
        line,
        capacidade || null,
        animation,
        hostId || connection.config?.hostOriginId,
        flagLimiteAutomatico,
        flagCapacidadeAutomatica,
        limiteSuperiorPowerRX,
        limiteInferiorPowerRX,
        limiteSuperiorPowerTX,
        limiteInferiorPowerTX,
        sourceHandle,
        targetHandle,
      );
    };

    function Session({ title }) {
      return (
        <Stack mb={0.5}>
          <Typography sx={styles.title}>{title}</Typography>
          <Divider />
        </Stack>
      );
    }
    function HeaderTitle({ title, Icon }) {
      return (
        <Stack direction="row" gap={2} alignItems="center">
          <Icon
            color="primary"
            sx={{
              fontSize: "28px",
            }}
          />
          <Typography sx={styles.text} ml="-5px">
            {title}
          </Typography>
        </Stack>
      );
    }

    const HeaderIconElement = ({ iconsElementPair, elementsPair }) => (
      <Stack width="100%" alignItems="center" justifyContent={"center"} gap={1}>
        {iconsElementPair?.img && (
          <IconTransform img={iconsElementPair?.img ?? ""} size="30px" />
        )}
        <Tooltip width="100px" title={elementsPair?.titulo}>
          <Typography
            sx={{
              width: "100%",
              fontSize: "14px",
              textAlign: "center",
              textTransform: "uppercase",
            }}
          >
            {elementsPair?.titulo.length > 20
              ? elementsPair?.titulo.substring(0, 20) + "..."
              : elementsPair?.titulo}
          </Typography>
        </Tooltip>
      </Stack>
    );
    const isOptionEqualToValue = (option, value) => {
      return option?.hostid === value?.hostid;
    };
    return (
      <Drawer
        key={connection?.id}
        variant="persistent"
        anchor={"right"}
        open={!!connection || openEnlaceBar}
        ani
        //onClose={() => close()}
        sx={styles.drawer}
      >
        <Paper sx={styles.header}>
          <HeaderIconElement
            iconsElementPair={iconsElementPair[0]}
            elementsPair={elementsPair[0] || { titulo: "Elemento de origem" }}
          />

          <DoubleArrowOutlined color="primary" sx={{ fontSize: "30px" }} />
          <HeaderIconElement
            iconsElementPair={iconsElementPair[1]}
            elementsPair={elementsPair[1] || { titulo: "Elemento de destino" }}
          />
        </Paper>

        {!!loading && (
          <Stack
            gap={2}
            sx={{
              maxHeight: "80vh",
              overflow: "auto",
            }}
          >
            <Stack sx={{ width: "100%" }}>
              <LinearProgress />
            </Stack>
          </Stack>
        )}
        {!loading && (
          <>
            <Stack sx={styles.container}>
              {typeElement != "Host" && editingViaElement && (
                <>
                  <Session title="Configurações Gerais" />
                  <Typography sx={styles.text}>
                    Selecione o host de origem
                  </Typography>
                  <Autocomplete
                    getOptionLabel={(option) => option?.host}
                    isOptionEqualToValue={isOptionEqualToValue}
                    sx={{
                      width: "100%",
                      backgroundColor: theme.palette.background.paperLinked,
                    }}
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    color="primary"
                    options={hostsConfig || []}
                    value={
                      hostsConfig?.find((host) => host.hostid === hostId) ||
                      null
                    }
                    onChange={(event, newValue) => {
                      setOtherItensConnection([]);
                      setInterfaceSelected(null);
                      setHostId(newValue ? newValue.hostid : null);
                    }}
                    ListboxComponent={VirtualizedListbox}
                    renderOption={(props, option, { selected }) => (
                      <li
                        {...props}
                        style={{ padding: "0px" }}
                        key={option.itemid}
                      >
                        <Tooltip
                          title={option.titulo}
                          placement="left-start"
                          arrow
                        >
                          <Stack sx={styles.stackOption}>
                            <Checkbox checked={selected} />
                            <span style={styles.textoLimitado}>
                              {option.host}
                            </span>
                          </Stack>{" "}
                        </Tooltip>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="primary"
                        variant="outlined"
                        label="Host"
                        sx={styles.textField}
                      />
                    )}
                  />
                </>
              )}
              <Stack gap={0.7}>
                {typeElement == "Host" && (
                  <Session title="Configurações Gerais" />
                )}
                <Typography sx={styles.text}>Elemento de Destino</Typography>
                <Autocomplete
                  getOptionLabel={(option) => option?.titulo}
                  disablePortal
                  key="elementDestineAutocomplete"
                  size="small"
                  color="primary"
                  options={[...elements.values()].filter(
                    (ele) => ele.id !== elementSelected?.id,
                  )}
                  value={element || null}
                  onChange={(event, newValue) => {
                    setElement(newValue);
                    if (!newValue) return;

                    // setConnection((prev) => {
                    //   const updated = {
                    //     ...prev,
                    //     destinationId: newValue.id,
                    //   };
                    //   return updated;
                    // });
                  }}
                  ListboxComponent={VirtualizedListbox}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{ padding: "0px" }}
                      key={option.titulo}
                    >
                      <Tooltip
                        title={option.titulo}
                        placement="left-start"
                        arrow
                      >
                        <Stack sx={styles.stackOption}>
                          <Checkbox checked={selected} />
                          <span style={styles.textoLimitado}>
                            {option.titulo}
                          </span>
                        </Stack>{" "}
                      </Tooltip>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={styles.textField}
                      color="primary"
                      variant="outlined"
                      placeholder="Elemento"
                    />
                  )}
                />
              </Stack>
              <HeaderTitle
                title={"Interface do host de origem"}
                Icon={LinkedIcon}
              />
              <Autocomplete
                disableCloseOnSelect
                key="interfaceAutocomplete"
                id="interfaceHost"
                size="small"
                color="primary"
                options={interfaces}
                getOptionLabel={(option) => {
                  if (Array.isArray(option) || !option) return {};
                  return option.description
                    ? option.interface + " - " + option.description
                    : option.interface;
                }}
                isOptionEqualToValue={(option, value) =>
                  option.interface == value.interface
                }
                ListboxComponent={VirtualizedListbox}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={{ padding: "0px" }}
                    key={option.interface}
                  >
                    <Tooltip
                      title={
                        option?.description
                          ? option?.interface + " - " + option?.description
                          : option?.interface
                      }
                      placement="left-start"
                      arrow
                    >
                      <Stack sx={styles.stackOption}>
                        <Checkbox checked={selected} />
                        <span style={styles.textoLimitado}>
                          {option?.description
                            ? option?.interface + " - " + option?.description
                            : option?.interface}
                        </span>
                      </Stack>{" "}
                    </Tooltip>
                  </li>
                )}
                value={interfaceSelected || null}
                onChange={(event, newValue) => {
                  setInterfaceSelected(newValue);
                  setCheckChanges(true);
                }}
                renderInput={(params) => (
                  <Tooltip
                    title={params.inputProps.value}
                    placement="left"
                    arrow
                  >
                    <TextField
                      key="interfaceText"
                      {...params}
                      sx={styles.textField}
                      color="primary"
                      placeholder="Interface"
                      helperText={
                        itens?.length == 0 && "Esse elemento não contém itens"
                      }
                    />
                  </Tooltip>
                )}
              />

              <HeaderTitle title={"Adicione outros itens"} Icon={ItemIcon} />

              <Autocomplete
                key="autoc-02"
                multiple
                disableCloseOnSelect
                disablePortal
                id="itensnoTraffic"
                size="small"
                color="primary"
                options={filterItemIsNotTrafficNotPower(itens)}
                value={[...otherItensConnection] || []}
                onChange={(event, newValue) => {
                  setOtherItensConnection(newValue);
                  setCheckChanges(true);
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option.name} key={index + "tool"}>
                      <Chip label={option.name} {...getTagProps({ index })} />
                    </Tooltip>
                  ))
                }
                ListboxComponent={VirtualizedListbox}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ padding: "0px" }} key={option.itemid}>
                    <Tooltip title={option.name} placement="left-start">
                      <Stack sx={styles.stackOption}>
                        <Checkbox checked={selected} />
                        <span style={styles.textoLimitado}>{option.name}</span>
                      </Stack>{" "}
                    </Tooltip>
                  </li>
                )}
                getOptionLabel={(option) => option?.name}
                isOptionEqualToValue={(option, value) =>
                  option?.itemid == value?.itemid
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    color="primary"
                    placeholder="Outros itens"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        startAdornment: (
                          <Stack
                            direction={"row"}
                            justifyContent={"center"}
                            alignItems={"center"}
                          >
                            <InputAdornment position="start">
                              <ViewInArOutlined
                                sx={{
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "20px",
                                }}
                              />
                            </InputAdornment>
                            <Stack
                              sx={{
                                maxWidth: "200px",
                              }}
                            >
                              {params.InputProps.startAdornment}
                            </Stack>
                          </Stack>
                        ),
                      },
                    }}
                  />
                )}
              />

              <HeaderTitle
                title={"Selecione a animação"}
                Icon={AnimationOutlined}
              />

              <TextField
                select
                size="small"
                value={animation}
                onChange={(event) => {
                  setCheckChanges(true);
                  setAnimation(event.target.value);
                }}
                placeholder="animação"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LineStyle
                          sx={{
                            ml: "-10px",
                            color: theme.palette.color.bgIcon,
                            fontSize: "22px",
                          }}
                        />
                      </InputAdornment>
                    ),
                  },
                }}
              >
                <MenuItem value="desativada">
                  <em>Desativada</em>
                </MenuItem>
                {animationTypes?.map((type, index) => (
                  <MenuItem key={index} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              {tipoMapa === 1 && (
                <>
                  <HeaderTitle
                    title={"Edite as posições de entrada e saída"}
                    Icon={SwitchAccessShortcut}
                  />

                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    gap={1}
                  >
                    <TextField
                      select
                      size="small"
                      value={targetHandle || "right"}
                      onChange={(event) => {
                        setCheckChanges(true);
                        setTargetHandle(event.target.value);
                      }}
                      fullWidth
                      placeholder="animação"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <Undo
                                sx={{
                                  transform: "rotate(-90deg)",
                                  ml: "-10px",
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "25px",
                                }}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                    >
                      <MenuItem value="top">
                        <em>Superior</em>
                      </MenuItem>
                      <MenuItem value="bottom">
                        <em>Inferior</em>
                      </MenuItem>
                      <MenuItem value="right">
                        <em>Direita</em>
                      </MenuItem>
                      <MenuItem value="left">
                        <em>Esquerda</em>
                      </MenuItem>
                    </TextField>
                    <TextField
                      select
                      size="small"
                      value={sourceHandle || "right"}
                      onChange={(event) => {
                        setCheckChanges(true);
                        setSourceHandle(event.target.value);
                      }}
                      fullWidth
                      placeholder="animação"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <Redo
                                sx={{
                                  transform: "rotate(-90deg)",
                                  ml: "-10px",
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "25px",
                                }}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                    >
                      <MenuItem value="top">
                        <em>Superior</em>
                      </MenuItem>
                      <MenuItem value="bottom">
                        <em>Inferior</em>
                      </MenuItem>
                      <MenuItem value="right">
                        <em>Direita</em>
                      </MenuItem>
                      <MenuItem value="left">
                        <em>Esquerda</em>
                      </MenuItem>
                    </TextField>
                  </Stack>
                </>
              )}

              {tipoMapa === 1 && (
                <>
                  <HeaderTitle
                    title={"Selecione o tipo de Linha"}
                    Icon={ShapeLineOutlined}
                  />

                  <TextField
                    select
                    size="small"
                    value={line}
                    onChange={(event) => {
                      setLine(event.target.value);
                      changeConnection(connection.id, {
                        type: event.target.value,
                      });
                      setCheckChanges(true);
                    }}
                    placeholder="Tipo de linha"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Timeline
                              sx={{
                                ml: "-10px",
                                color: theme.palette.color.bgIcon,
                                fontSize: "22px",
                              }}
                            />
                          </InputAdornment>
                        ),
                      },
                    }}
                  >
                    {lineTypes?.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {/* <Camera /> */}
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}

              {tipoMapa == 0 && !editingViaElement && (
                <>
                  <HeaderTitle
                    title={" Roteamento automático"}
                    Icon={ForkRightIcon}
                  />
                  <Stack gap={1} direction={"row"}>
                    <Button
                      loading={loading}
                      sx={styles.buttonRoter}
                      disabled={loadRouting}
                      onClick={() => {
                        setCheckChanges(true);
                        autoRouting(connection);
                      }}
                    >
                      {!loadRouting ? (
                        <>
                          <NearMeIcon />
                          <Typography sx={styles.textButtonRoter}>
                            Encontrar rota
                          </Typography>
                        </>
                      ) : (
                        <CircularProgress size={30} color="primary" />
                      )}
                    </Button>
                    <Button
                      sx={styles.buttonRoter}
                      disabled={loadRouting}
                      onClick={() => {
                        setCheckChanges(true);
                        cleanRouting(connection);
                      }}
                    >
                      <CleaningServicesOutlinedIcon />
                      <Typography sx={styles.textButtonRoter}>
                        Limpar Pontos
                      </Typography>
                    </Button>
                  </Stack>
                </>
              )}
              <Session title="Configurações de Tráfego" />

              <HeaderTitle
                title={"Informe a capacidade máxima (Gb)"}
                Icon={CapacityIcon}
              />
              <Stack
                direction="row"
                alignItems="center"
                gap={0.5}
                mb={flagCapacidadeAutomatica ? 1 : 0}
              >
                <Checkbox
                  checked={flagCapacidadeAutomatica}
                  onChange={(event) => {
                    setflagCapacidadeAutomatica(event.target.checked);
                    setCheckChanges(true);
                  }}
                  sx={{ p: 0 }}
                />
                <Typography sx={styles.text}>
                  Usar Capacidade do Zabbix
                </Typography>
              </Stack>
              {!flagCapacidadeAutomatica && (
                <TextField
                  size="small"
                  type="text"
                  value={capacidade}
                  onChange={(e) => {
                    const value = e.target.value;
                    const partes = value
                      .replace(",", ".")
                      .replace(/[^0-9.]/g, "")
                      .split(".");

                    const sanitizedValue =
                      partes.length > 1
                        ? `${partes[0]}.${partes.slice(1).join("")}`
                        : partes[0];

                    setCapacidade(sanitizedValue);
                    setCheckChanges(true);
                  }}
                />
              )}
              <Session title="Configurações de Potência" />
              <Stack
                direction="row"
                alignItems="center"
                gap={0.5}
                mb={flagLimiteAutomatico ? 1 : 0}
              >
                <Checkbox
                  checked={flagLimiteAutomatico}
                  onChange={(event) => {
                    setFlagLimiteAutomatico(event.target.checked);
                    setCheckChanges(true);
                  }}
                  sx={{ p: 0 }}
                />
                <Typography sx={styles.text}>
                  Usar limiares do Zabbix
                </Typography>
              </Stack>
              {!flagLimiteAutomatico && (
                <>
                  <Stack
                    display={"flex"}
                    direction={"row"}
                    gap={1.5}
                    width={"100%"}
                  >
                    <Stack>
                      <HeaderTitle
                        title={"Limite Superior TX (dBm)"}
                        Icon={SignalCellularAltIcon}
                      />
                      <TextField
                        placeholder="Limite Superior TX"
                        size="small"
                        value={limiteSuperiorPowerTX}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          const partes = value
                            .replace(",", ".")
                            .replace(/(?!^-)[^0-9.]/g, "")
                            .split(".");

                          const sanitizedValue =
                            partes.length > 1
                              ? `${partes[0]}.${partes.slice(1).join("")}`
                              : partes[0];

                          setLimiteSuperiorPowerTX(sanitizedValue);
                          setCheckChanges(true);
                        }}
                        sx={styles.textField}
                      />
                    </Stack>
                    <Stack gap={0.5}>
                      <HeaderTitle
                        title={"Limite Inferior TX (dBm)"}
                        Icon={SignalCellularAltIcon}
                      />
                      <TextField
                        placeholder="Limite Inferior TX"
                        size="small"
                        value={limiteInferiorPowerTX}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          const partes = value
                            .replace(",", ".")
                            .replace(/(?!^-)[^0-9.]/g, "")
                            .split(".");

                          const sanitizedValue =
                            partes.length > 1
                              ? `${partes[0]}.${partes.slice(1).join("")}`
                              : partes[0];
                          setLimiteInferiorPowerTX(sanitizedValue);
                          setCheckChanges(true);
                        }}
                        sx={styles.textField}
                      />
                    </Stack>{" "}
                  </Stack>
                  <Stack
                    display={"flex"}
                    direction={"row"}
                    gap={1.5}
                    width={"100%"}
                  >
                    <Stack gap={0.5}>
                      <HeaderTitle
                        title={"Limite Superior RX (dBm)"}
                        Icon={SignalCellularAltIcon}
                      />
                      <TextField
                        placeholder="Limite Superior RX"
                        size="small"
                        value={limiteSuperiorPowerRX}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          const partes = value
                            .replace(",", ".")
                            .replace(/(?!^-)[^0-9.]/g, "")
                            .split(".");

                          const sanitizedValue =
                            partes.length > 1
                              ? `${partes[0]}.${partes.slice(1).join("")}`
                              : partes[0];
                          setLimiteSuperiorPowerRX(sanitizedValue);
                          setCheckChanges(true);
                        }}
                        sx={styles.textField}
                      />
                    </Stack>
                    <Stack gap={0.5}>
                      <HeaderTitle
                        title={"Limite Inferior RX (dBm)"}
                        Icon={SignalCellularAltIcon}
                      />
                      <TextField
                        placeholder="Limite Inferior RX"
                        size="small"
                        value={limiteInferiorPowerRX}
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          const partes = value
                            .replace(",", ".")
                            .replace(/(?!^-)[^0-9.]/g, "")
                            .split(".");

                          const sanitizedValue =
                            partes.length > 1
                              ? `${partes[0]}.${partes.slice(1).join("")}`
                              : partes[0];
                          setLimiteInferiorPowerRX(sanitizedValue);
                          setCheckChanges(true);
                        }}
                        sx={styles.textField}
                      />
                    </Stack>
                  </Stack>
                </>
              )}
            </Stack>

            <Stack
              direction="column"
              sx={{
                position: "absolute",
                bottom: 0,
                center: 0,
                left: 0,
                right: 0,
                mb: 4,
              }}
            >
              <Divider />
              <Stack
                direction="row"
                justifyContent={"space-around"}
                paddingTop={1.5}
              >
                {!editingViaElement && connection?.id && (
                  <Button
                    sx={styles.buttonBottom}
                    color="primary"
                    variant="text"
                    //endIcon={<DeleteOutline />}
                    startIcon={<DeleteOutline />}
                    onClick={() => {
                      setCheckChanges(false);
                      handleDelete(connection.id);
                    }}
                  >
                    {"Remover"}
                  </Button>
                )}
                <Button
                  sx={styles.buttonBottom}
                  color="primary"
                  variant="text"
                  startIcon={<CancelOutlined />}
                  onClick={() => {
                    checkChanges
                      ? setOpenAlertModal({
                          open: true,
                          severity: "warning",
                          text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                          callback: () => close(),
                        })
                      : close();
                  }}
                >
                  {editingViaElement ? "Voltar" : "Cancelar"}
                </Button>

                <LoadingButton
                  sx={[
                    styles.buttonBottom,
                    {
                      color: theme.palette.text.primary,
                      "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      },
                    },
                  ]}
                  color="primary"
                  variant="text"
                  loading={loadingButton}
                  disabled={
                    element == null ||
                    (typeElement !== "Host" && hostId == null)
                  }
                  startIcon={editingViaElement ? <SaveAs /> : <SaveOutlined />}
                  onClick={() => {
                    handleSave();
                    close();
                  }}
                >
                  {"Salvar"}
                </LoadingButton>
              </Stack>
            </Stack>
          </>
        )}
      </Drawer>
    );
  },
);
export default EnlaceSideBarEasyMaps;
